"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _icons = require("../../assets/icons");

var _Field = require("../Field/Field.styles");

var _Field2 = require("../Field/Field");

var _Search = require("./Search.styles");

var _elements = require("../../styles/elements");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Search = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      loading = _ref.loading,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "onFocus", "onBlur", "value", "onChange", "disabled", "loading"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var handleFocus = (0, _react.useCallback)(function (e) {
    setFocused(true);
    onFocus(e);
  }, [onFocus]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setFocused(false);
    onBlur(e);
  }, [onBlur]);
  var handleClick = (0, _react.useCallback)(function (e) {
    var inputElement = e.currentTarget.previousElementSibling;

    if (!loading && value) {
      onChange({
        target: Object.assign(inputElement, {
          value: ''
        })
      });
      inputElement.focus();
    }
  }, [onChange, value, loading]);
  return (0, _jsxRuntime.jsx)("div", {
    css: _Field.styles.fieldContainer,
    className: className,
    children: (0, _jsxRuntime.jsxs)(_Field2.FormControl, {
      focused: focused,
      css: _Search.searchStyles.base,
      disabled: disabled,
      children: [(0, _jsxRuntime.jsx)("input", _objectSpread({
        type: "text",
        className: "grui",
        css: _elements.input.styles.preflight,
        onFocus: handleFocus,
        onBlur: handleBlur,
        value: value,
        onChange: onChange,
        ref: ref,
        autoComplete: "off",
        disabled: disabled
      }, otherProps)), (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        className: "grui",
        css: [_elements.button.styles.preflight, _Search.searchStyles.searchIcon, !value && _Search.searchStyles.searchBtn, process.env.NODE_ENV === "production" ? "" : ";label:Search;"],
        onClick: handleClick,
        children: [loading && (0, _jsxRuntime.jsx)(_icons.OvalLoader, {}), !loading && value && (0, _jsxRuntime.jsx)(_icons.Close, {}), !loading && !value && (0, _jsxRuntime.jsx)(_icons.Search, {})]
      })]
    })
  });
});
Search.propTypes = {
  className: _propTypes.string,
  onFocus: _propTypes.func,
  onBlur: _propTypes.func,
  value: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  disabled: _propTypes.bool,
  loading: _propTypes.bool
};
Search.defaultProps = {
  className: undefined,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  disabled: false,
  loading: false
};
Search.displayName = 'Search';
var _default = Search;
exports["default"] = _default;
//# sourceMappingURL=Search.js.map